// extracted by mini-css-extract-plugin
export default {"hidescrollbar":"CandidateDashboardMessage_hidescrollbar__ohiXN","input":"CandidateDashboardMessage_input__uCaId","customBadge":"CandidateDashboardMessage_customBadge__8+H3M"};